import React from "react";
import { Pill } from "../../Pill";
import classNames from "classnames/bind";
import styles from "./PrimaryCard.module.scss";

const cx = classNames.bind(styles);

type PrimaryCardPillsType = {
  /** keywords related to the card to help categorize it */
  pills?: string[];
};

const PrimaryCardPills = ({ pills = [] }: PrimaryCardPillsType) => {
  const maxPillList = pills?.slice(0, 3) ?? [];
  if (maxPillList.length > 0) {
    const pillList = maxPillList.map((label) => {
      return (
        <div key={label}>
          <Pill variant="default">{label}</Pill>
        </div>
      );
    });

    return <div className={cx("pillsContainerOpen")}>{pillList}</div>;
  }

  return <div className={cx("pillsContainerClosed")} />;
};

export default PrimaryCardPills;
